// src/validation/configInplaySchema.ts
import { z } from 'zod';

export const configInplaySchema = z.object({
  emailAdministracao: z.string().trim().email('Informe um e-mail válido.'),
});

export type ConfigInplayFormValues = z.infer<typeof configInplaySchema>;
